import React from 'react';
import PropTypes from 'prop-types';
import columns from '../CartLanding/constants/columns';

import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';

const ReviewTable = (props) => {
	const { cartData, subtotal } = props;

	const determineSubtotal = (price, quantity) => {
		let subtotal = price;

		subtotal = quantity && price * quantity;

		return subtotal;
	};

	return (
		<TableContainer className='filter' component={Paper}>
			<Table aria-label='review-order-table'>
				<TableHead>
					<TableRow sx={{ bgcolor: 'lightgrey' }}>
						{columns.map((column, index) => {
							return (
								<TableCell
									colSpan={column.colSpan}
									width={column.width}
									align={column.align}
									key={index}
								>
									{column.title}
								</TableCell>
							);
						})}
					</TableRow>
				</TableHead>
				<TableBody>
					{cartData?.map((item) => {
						return (
							<TableRow key={item.id}>
								<TableCell colSpan={2}>
									<Box
										component='img'
										src={item.image}
										alt={`${item.company} Gift Card`}
										sx={{ width: { xs: '40px', md: '70px' } }}
									/>
								</TableCell>
								<TableCell colSpan={3}>
									${item.amount} {item.company} Gift Card
								</TableCell>
								<TableCell>${item.price}.00</TableCell>
								<TableCell align='center'>{item?.quantity}</TableCell>
								<TableCell align='right'>
									${determineSubtotal(item?.price, item?.quantity)}.00
								</TableCell>
							</TableRow>
						);
					})}
					<TableRow>
						<TableCell colSpan={7}>
							<Typography
								variant='h6'
								sx={{
									fontSize: {
										xs: '0.8rem',
										sm: '0.9rem',
										lg: '1rem',
										xl: '1.05rem'
									}
								}}
							>
								Subtotal
							</Typography>
						</TableCell>
						<TableCell align='right'>${subtotal}.00</TableCell>
					</TableRow>
					<TableRow>
						<TableCell colSpan={7}>
							<Typography
								variant='h6'
								sx={{
									fontSize: {
										xs: '0.8rem',
										sm: '0.9rem',
										lg: '1rem',
										xl: '1.05rem'
									}
								}}
							>
								Total
							</Typography>
						</TableCell>
						<TableCell align='right'>${subtotal}.00</TableCell>
					</TableRow>
				</TableBody>
			</Table>
		</TableContainer>
	);
};

ReviewTable.propTypes = {
	cartData: PropTypes.array,
	subtotal: PropTypes.number
};

export default ReviewTable;
